import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { AppConstants } from '../../../shared/constants/constants';
@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private DOC_PAC_BASE_URL = this.appconstants.API_BASE_URL_DOCUMENTPACKAGE;
  groupedPackagesSubject = new BehaviorSubject([]);
  skip = 0;
  take = 15;
  sortParameterValue: SortDescriptor[] = [{ field: 'lastModified', dir: 'desc' }];
  packageFormType = 'create';
  docPackageId: number;
  packageName: string;
  viewHistory = false;
  generateBtnChecked = false;
  isEnablePackage = new BehaviorSubject<boolean>(true);
  constructor(private httpClient: HttpClient, private appconstants: AppConstants) { }


  getDocumentFileDownload(drAddressId: number, jobId: number, documentPackageId: number, version: number) {
    const url = `${this.DOC_PAC_BASE_URL}/${drAddressId}/Jobs/${jobId}/DocumentPackages/${documentPackageId}/Files/${version}/Download`;
    return this.getFileDownload(url);
  }

  private getFileDownload(url: string): Observable<{ file: Blob, name: string }> {
    return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
      .pipe(map((res) => {
        // We assume the filename is unicode, or the browser supports unicode (filename* exists on content-disposition header)
        // content-disposition: attachment; filename="(non-unicode filename)"; filename*="(encoding type)''(unicode filename)";
        const contentDispositionHeader = res.headers.get('Content-Disposition');

        // Read from filename* for unicode filename (browser may or may not support this, peel off encoding type like UTF-8).
        const unicodeFilenameRegex = /filename\*?=(UTF-\d['"]*)([^;\r\n"']*)['"]?;?/;
        let fileName = '';

        // Encoded unicode filename will be null or 0 length if the browser does not support unicode.
        const encodedUnicodeFilename = unicodeFilenameRegex.exec(contentDispositionHeader);
        if (encodedUnicodeFilename === null || encodedUnicodeFilename.length === 0) {
          // Non-unicode filename.
          // Read from filename (note: no *)
          const nonunicodeFilenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          fileName = contentDispositionHeader ? nonunicodeFilenameRegex.exec(contentDispositionHeader)[1].replace(/["]/g, '') : '';
        } else {
          // Unicode filename (contains something like: éèâîôñüïç).
          // Already read from filename*.
          const escapedFileName = contentDispositionHeader ?
            unicodeFilenameRegex.exec(contentDispositionHeader)[2].replace(/["]/g, '') : '';
          fileName = unescape(decodeURIComponent(escapedFileName));
        }

        return {
          file: new Blob([res.body], { type: res.headers.get('Content-Type') }),
          name: fileName,
        };

      }), catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
